import React from 'react';
import './skills.css';
import SkillCategory from './SkillCategory';
import portfolioData from '../../portfolio.json';

export default function Skills() {
  const { skills } = portfolioData;
  return (
    <section className='skills section' id="skills">
      <h2 className='section__title'>{skills.title}</h2>
      <span className='section__subtitle'>{skills.subtitle}</span>
      <div className='skills__container container grid'>
        {skills.categories.map((category, index) => (
          <SkillCategory key={index} category={category} />
        ))}
      </div>
    </section>
  )
}
